
import { ProfileTranslationType } from "../../features/profile.types";

export const profile: ProfileTranslationType = {
  profile: {
    title: "الملف الشخصي",
    dangerZone: "منطقة الخطر",
    deleteAccount: "حذف الحساب",
    confirmDelete: "تأكيد الحذف",
    deleteWarning: "هل أنت متأكد من رغبتك في حذف حسابك؟ هذا الإجراء لا يمكن التراجع عنه.",
    confirmDeleteButton: "حذف الحساب",
    accountDeleted: "تم حذف الحساب",
    accountDeletedMessage: "تم حذف حسابك بنجاح."
  },
  common: {
    cancel: "إلغاء",
    delete: "حذف",
    deleteConfirmation: "تأكيد الحذف",
    deleteConfirmationMessage: "هل أنت متأكد أنك تريد حذف"
  }
};
